<template>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Entité:</label>
        </div>
        <div class="col-lg-9">
          <Dropdown
              class="input-width-100"
              v-model="entite"
              :options="entiteLibelles"
              optionValue="valeur"
              optionLabel="texte"
              v-on:keyup.enter="imprimer"
              scrollHeight="700px"
              :showClear="true"
          />
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Site d'origine:</label>
        </div>
        <div class="col-lg-9">
          <Dropdown
              class="input-width-100"
              v-model="siteOrigine"
              :options="sitesLibelles"
              optionValue="valeur"
              optionLabel="texte"
              @:keyup.enter="imprimer"
              scrollHeight="205px"
              :showClear="true"
          />
        </div>
      </div>
    </div>
  </div>

  <template v-if="cacherChampGenre == false">
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-2 lbl text-vertical-center">
            <label>Genre :</label>
          </div>
          <div class="col-lg-6">
            <Dropdown class="dropdown-height"
                      v-model="genre"
                      :options="genreLibelles"
                      optionValue="valeur"
                      optionLabel="texte"
                      scrollHeight="205px"
                      :showClear="true"/>
          </div>
        </div>
      </div>
      <div class="col-3"></div>
    </div>
  </template>

  <template v-if="cacherChampNature == false">
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-2 lbl">
            <label>Nature :</label>
          </div>
          <div class="col-lg-6">
            <Dropdown class="dropdown-height" v-model="nature"
                      :options="natureLibelles"
                      optionValue="valeur"
                      optionLabel="texte"
                      scrollHeight="205px"
                      :showClear="true"/>
          </div>
        </div>
      </div>
      <div class="col-3"></div>
    </div>

  </template>

  <template v-if="cacherChampIntervenant == false">
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-lg-2 lbl">
            <label>Intervenant:</label>
          </div>
          <div class="col-lg-6">
            <div v-if="intervenantsLoading == true" class="">
              <vue-loaders name="ball-beat"></vue-loaders>
            </div>
            <div v-else>
              <Dropdown
                  class="input-width-100"
                  v-model="intervenant"
                  :options="intervenantLibelles"
                  optionValue="codeProfil"
                  optionLabel="description"
                  v-on:keyup.enter="imprimer"
                  scrollHeight="700px"
                  :showClear="true"
                  filter
                  filterPlaceholder="Rechercher..."
                  filterMatchMode="startsWith"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-3"></div>
    </div>
  </template>

  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Du:</label>
        </div>
        <div class="col-lg-9">
          <CustomInputDate
              class="input-width-100"
              type="date"
              max="9999-12-31"
              v-model="dateDu"
              v-on:keyup.enter="imprimer"
          />
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Au:</label>
        </div>
        <div class="col-lg-9">
          <CustomInputDate
              class="input-width-100"
              type="date"
              max="9999-12-31"
              v-model="dateAu"
              v-on:keyup.enter="imprimer"
          />
        </div>
      </div>
    </div>
  </div>

  <template v-if="cacherChampActivite == false">
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-lg-2 lbl">
            <label>Activité:</label>
          </div>
          <div class="col-lg-6">
            <Dropdown
                class="input-width-100"
                v-model="activite"
                :options="activiteLibelles"
                optionValue="valeur"
                optionLabel="texte"
                v-on:keyup.enter="imprimer"
                scrollHeight="700px"
                :showClear="true"
            />
          </div>
        </div>
      </div>
      <div class="col-3"></div>
    </div>
  </template>
</template>

<script>
import {mapGetters} from "vuex";
import CustomInputDate from '../../Commun/CustomInputDate.vue'

export default {
  name: "CritereRechercheSuivis",
  emits: ['imprimer'],
  components: {
    CustomInputDate
  },
  props: {
    cacherChampGenre: {
      type: Boolean,
      default: true,
    },
    cacherChampNature: {
      type: Boolean,
      default: true,
    },
    cacherChampIntervenant: {
      type: Boolean,
      default: false,
    },
    cacherChampActivite: {
      type: Boolean,
      default: false,
    },
    entiteDefault: {
      type: Number,
      default: null,
    },
    siteDefault: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      entite: null,
      siteOrigine: null,
      genre: null,
      nature: null,
      intervenant: null,
      dateDu: null,
      dateAu: null,
      activite: 0,

      entiteLibelles: [],
      sitesLibelles: [],
      genreLibelles: [],
      natureLibelles: [],
      intervenantLibelles: [],
      activiteLibelles: [],

      intervenantsLoading: false,
      critereRechercheSuivis: {}
    };
  },

  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },


  methods: {
    assignerListe(entiteDecision) {
      this.entiteLibelles = entiteDecision.entite.libelles;
      this.entite = this.entiteDefault;
      this.siteOrigine = this.siteDefault;
      this.dateDefault();
    },
    dateDefault() {
      let dateDefaut = new Date();
      this.dateDu = this.$commun.formatDate(dateDefaut.setDate(dateDefaut.getDate() - 7));
      this.dateAu = this.$commun.formatDate(new Date());
    },
    getCritereRecherche() {
      if (this.dateAu !== null && this.dateAu !== undefined) {
        this.critereRechercheSuivis.dateAu = new Date(this.dateAu);
      }
      if (this.dateDu !== null && this.dateDu !== undefined) {
        this.critereRechercheSuivis.dateDu = new Date(this.dateDu);
      }

      this.critereRechercheSuivis.entite = this.entite;
      this.critereRechercheSuivis.intervenant = this.intervenant;
      this.critereRechercheSuivis.siteOrigine = this.siteOrigine;
      this.critereRechercheSuivis.genre = this.genre;
      this.critereRechercheSuivis.nature = this.nature;
      this.critereRechercheSuivis.activite = this.activite;
      return this.critereRechercheSuivis;
    },
    imprimer() {
      this.$emit("imprimer");
    },
  },

  watch: {
    entite: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch("dossier/onChangeEntityAction", {
          libelleChange: 'Site',
          nouvelleValeur: [val]
        })
            .then((res) => {
              this.sitesLibelles = res.data;
            });
        this.$store.dispatch('dossier/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Genre',
          nouvelleValeur: val
        })
            .then((res) => {
              this.genreLibelles = res.data;
            });
        this.$store.dispatch('dossier/onChangeEntityAction', {
          libelleChange: 'TypeActivite',
          nouvelleValeur: [val]
        }).then((res) => {
          this.activiteLibelles = res.data;
        });
      } else {
        this.siteOrigine = null;
        this.sitesLibelles = [];
        this.genre = null;
        this.genreLibelles = [];
        this.activite = null;
        this.activiteLibelles = [];
      }
    },
    siteOrigine: function (val) {
      if (val !== null && val !== undefined) {
        this.intervenantsLoading = true;
        this.$store.dispatch('dossier/obtenirListeIntervenantsAction', {
          site: [val]
        })
            .then((res) => {
              this.intervenantLibelles = res.data.sort(this.$commun.compareIntervenant);
              this.intervenantsLoading = false;
            })
      } else {
        this.intervenantLibelles = [];
        this.intervenant = null;
      }
    },
    genre: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('dossier/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Nature',
          nouvelleValeur: val
        })
            .then((res) => {
              this.natureLibelles = res.data;
            });
      } else {
        this.nature = null;
        this.natureLibelles = [];
      }
    },
  }
}
</script>